/**
 * A dónde lleva una notificación (SRH-316, A-05).
 *
 * Cada notificación trae el enlace de lo que la causó, pero la campanita
 * llevaba siempre al panel general porque varios enlaces apuntaban a rutas que
 * no existen (`/vacantes/…`). El servidor ya los corrigió; esto solo deja pasar
 * los destinos que el front sí sirve y, con cualquier otro, cae al panel: un
 * enlace de más no debe terminar en una pantalla en blanco.
 *
 * Lista cerrada a propósito: las notificaciones de otros módulos traen enlaces
 * propios que esta función no conoce, y para ellos el comportamiento no cambia.
 */
const DESTINOS_VALIDOS: RegExp[] = [
  /^\/job-requests\/\d+$/,
  /^\/candidate\/[0-9a-f-]{36}$/i,
  /^\/hiring\/hire\/[0-9a-f-]{36}$/i,
  /^\/hiring-manager-interviews$/,
  /^\/hr-interviews$/,
  /^\/rh\/validacion-direccion$/,
  /^\/rh\/cierre-seleccion$/,
]

/**
 * El destino de la notificación, o nulo si su enlace no se puede abrir.
 *
 * La consulta se descarta (`?tab=…` no se sigue), salvo `?entrevista=<id>` en el
 * listado de entrevistas del solicitante: ahí le dice a la pantalla cuál abrir
 * (SRH-324).
 */
export const destinoDeNotificacion = (
  enlace: string | null | undefined,
): string | null => {
  const [ruta, consulta = ''] = (enlace ?? '').trim().split('?')
  if (!DESTINOS_VALIDOS.some((patron) => patron.test(ruta))) return null

  const abreUnaEntrevista =
    ruta === '/hiring-manager-interviews' && /^entrevista=\d+$/.test(consulta)
  return abreUnaEntrevista ? `${ruta}?${consulta}` : ruta
}
